<!-- <div class="not-found">
  <h1>
    {{header}}
  </h1>
  <ion-label
    class="not-found__message"
    *ngIf="message"
  >
    {{message}}
  </ion-label>
  <ion-back-button
    fill="clear"
    size="large"
    [defaultHref]="link"
    text="{{ returnText | translate }}"
    class="not-found__link-button"
  >
    <ion-icon name="arrow-back-outline"></ion-icon>
  </ion-back-button>
</div> -->

<ion-grid fixed class="h-100 display-flex ion-justify-content-center">
  <ion-row class="page-not-found__container">
    <ion-col size="1" *ngIf="!p.renderSmallDesktop"> </ion-col>
    <ion-col size-xl="5" size="12" class="page-not-found__left-column">
      <h1 class="page-not-found__header">
        {{ status }} {{ "ERROR.ERROR" | translate }}
      </h1>
      <h2 class="page-not-found__subheader">
        {{ header }}
      </h2>
      <p class="page-not-found__description">
        {{ message }}
      </p>
      <ion-back-button
        [icon]="undefined"
        [defaultHref]="link"
        color="primary"
        class="page-not-found__link-button"
        text="{{ returnText | translate }}"
      >
      </ion-back-button>
    </ion-col>
    <ion-col size-xl="5" size="12" class="page-not-found__right-column">
      <img
        src="./../../assets/images/404.png"
        alt="404"
        class="page-not-found__image"
      />
    </ion-col>
    <ion-col size="1" *ngIf="!p.renderSmallDesktop"> </ion-col>
  </ion-row>
</ion-grid>
